import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { avertissementDate } from '@/lib/lmdsJours';

// 🧾 Phase 3A : formulaire d'un jour admissible (date + note) — avertissement non bloquant si pas une fin de semaine.
export function FormulaireJourAdmissible({ installateurs, installateurId, onSoumettre, enCours, initial, onAnnuler }) {
  const [f, setF] = useState({ installateur_id: initial?.installateur_id || installateurId || '', date: initial?.date || '', note: initial?.note || '' });
  const avert = avertissementDate(f.date);
  const valide = f.installateur_id && /^\d{4}-\d{2}-\d{2}$/.test(f.date);
  const soumettre = (e) => {
    e.preventDefault();
    onSoumettre(initial ? { date: f.date, note: f.note } : f).then((ok) => ok && !initial && setF((p) => ({ ...p, date: '', note: '' })));
  };
  return (
    <form onSubmit={soumettre} className="grid gap-3 md:grid-cols-3 items-end" data-testid={initial ? 'formulaire-jour-modifier' : 'formulaire-jour-admissible'}>
      {!initial && (
        <div>
          <Label>Installateur</Label>
          <select className="w-full border rounded-md h-9 px-2 text-sm bg-white" value={f.installateur_id} data-testid="jour-installateur" onChange={(e) => setF({ ...f, installateur_id: e.target.value })}>
            <option value="">— Choisir —</option>
            {installateurs.map((i) => <option key={i.id} value={i.id}>{i.nom}</option>)}
          </select>
        </div>
      )}
      <div>
        <Label>Date (samedi ou dimanche)</Label>
        <Input type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="jour-date" />
        {avert && <p className="text-xs text-amber-700 mt-1" data-testid="jour-avertissement">{avert}</p>}
      </div>
      <div>
        <Label>Note (facultatif)</Label>
        <Input value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="Ex. Installation urgente" data-testid="jour-note" />
      </div>
      <div className="md:col-span-3 flex gap-2">
        <Button type="submit" disabled={!valide || enCours} data-testid="jour-soumettre">{initial ? 'Enregistrer' : 'Ajouter le jour'}</Button>
        {initial && <Button type="button" variant="outline" onClick={onAnnuler} data-testid="jour-annuler-modif">Annuler</Button>}
      </div>
    </form>
  );
}
